module.exports = __webpack_public_path__ + "img/icon-pont.09ae1d09.svg";